
import * as Store from "@/store/StoreTypes";
// Dependencies
import { mapState } from "vuex";
import { PageEditor } from "@/assets/scripts/PageEditor";
import { defineComponent } from "vue";
import { AtomicPropertyMetrics } from "@/assets/scripts/Page/Property";

export default defineComponent({
  name: "AppMetricsBar",
  computed: {

    /**
     * Application Store data
     */
    ...mapState<any, {
      editor  : (state: Store.ApplicationStore) => PageEditor,
    }>("ApplicationStore", {
      editor(state: Store.ApplicationStore): PageEditor {
        return state.activeEditor;
      }
    }),

    /**
     * Returns the selected property's metrics.
     * @returns
     *  The selected property's metrics, `null` if no property is selected.
     */
    propertyMetrics(): AtomicPropertyMetrics | null {
      return this.editor.selected?.metrics ?? null;
    }

  }
});
